export default "__VITE_ASSET__CzRlav_r__"